// extracted by mini-css-extract-plugin
export var jobsContainer = "styles-module__jobsContainer___IuFq5";
export var heading = "styles-module__heading___vuDsX";
export var subHeading = "styles-module__subHeading___JWUaa";
export var smallMargin = "styles-module__smallMargin___DvAUf";
export var adminButton = "styles-module__adminButton___m2Xby";
export var tabsContainer = "styles-module__tabsContainer___vvZma";
export var tabBar = "styles-module__tabBar___uOjVq";
export var textColorInherit = "styles-module__textColorInherit___y_LNk";
export var linkedInIcon = "styles-module__linkedInIcon___g54gY";
export var allPostings = "styles-module__allPostings___pS0HY";
export var expandableWrapper = "styles-module__expandableWrapper___u3e6S";
export var postingContainer = "styles-module__postingContainer___y8rEs";
export var applyButton = "styles-module__applyButton___D8MXH";
export var departmentText = "styles-module__departmentText___fTnGn";
export var postingTitle = "styles-module__postingTitle___C1Jja";
export var commitmentText = "styles-module__commitmentText___jxHbU";